import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../../custom/BackButton';
import ActionIcon from '../../custom/ActionIcon';
import { createdUpdatedInfo, formatMawb } from '../../../utils';
import { IRack, SetFieldValue } from '../../../globals/interfaces';
import { Input } from 'reactstrap';
import _ from 'lodash';

interface Props {
    selectedRackItem: IRack | null;
    modal: boolean;
    setModal: (state: boolean) => void;
    updateRackStatus: (s_status: string, s_notes: string) => Promise<void>;
}

export default function ModalConfirmDelete ({
    selectedRackItem,
    modal,
    setModal,
    updateRackStatus
}: Props) {

    const [s_notes, set_s_notes] = useState('');
    const [loading, setLoading] = useState(false);
    const enableDelete = _.get(s_notes, 'length', 0) >= 3;

    const toggle = () => setModal(!modal);

    const handleDelete = async () => {
        setLoading(true);
        await updateRackStatus('DELETED', s_notes);
        setLoading(false);
        toggle();
    }

    useEffect(() => {
        set_s_notes('');
    }, [modal]);

    if (!selectedRackItem) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Delete AWB {formatMawb(selectedRackItem.s_mawb)} in {selectedRackItem.s_location}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <Label>Delete Reason</Label>
                <Input 
                    type={'textarea'}
                    value={s_notes}
                    onChange={e => set_s_notes(e.target.value)}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(selectedRackItem)}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'delete'} 
                            disabled={!enableDelete}
                            loading={loading}
                            onClick={() => handleDelete()} 
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;